module.exports = __webpack_public_path__ + "img/bg-character.73bc4dfb.png";